import * as React from "react";
import { memo } from "react";
const SvgCaretLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.5 16.25L6.25 10L12.5 3.75", stroke: "white", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const Memo = memo(SvgCaretLeft);
export default Memo;
